import React from 'react';
import CardLayout from '../../../../../../../shared/components/card/CardLayout';
import { useTranslation } from 'react-i18next';
import { IFavoriteList } from '../../../../../global-discovery/dto/IFavoriteList';

interface IExternalProfileSavedListsCardProps {
    discoveryLists?: IFavoriteList[];
}

const ExternalProfileSavedListsCard = ({ discoveryLists }: IExternalProfileSavedListsCardProps) => {
    const { t } = useTranslation();
    return (
        <>
            <CardLayout classCard="mt-3" classBody="">
                <h6>{t('brand.campaign.discovery.external_list_title')}</h6>
                <div style={{ maxHeight: '280px' }} className="overflow-auto">
                    {discoveryLists?.map((list, index) => (
                        <p className="mb-1" key={list?.id}>
                            {index + 1}. {list.title}
                        </p>
                    ))}
                </div>
            </CardLayout>
        </>
    );
};

export default ExternalProfileSavedListsCard;
